export default __webpack_public_path__ + "static/cp-szenarios-66f2347960c3e25bdef944c10384a39a.webm";